import { getUserContext } from "../utils/auth";

export const attachRequestInterceptor = (apiInstance) => {
    apiInstance.interceptors.request.use(
        (config) => {
            if (!config.headers) {
                config.headers = {};
            }

            const { accessToken, businessId } = getUserContext();

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            } else {
                delete config.headers.Authorization;
            }

            if (businessId) {
                config.headers["x-business-id"] = businessId;
            } else {
                delete config.headers["x-business-id"];
            }

            return config;
        },
        (error) => Promise.reject(error)
    );
};

